import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { PackingListRead } from '../../entities/packing-list.dto';

@Injectable()
export class PackingListStore extends AbstractEntityStore<PackingListRead> {
    constructor() {
        super(PFWmsEntities.PackingList);
    }
}
